export default __webpack_public_path__ + "static/icon-interactivity-c8cc5bc226f867c94849decbefdd4c0e.svg";